/*
 * Sens Ēve — EvoBeauty PDP add-to-cart → drawer bridge (v2).
 * #evob2-form uses a classic POST → full reload. Intercept, add via
 * /cart/add.js, morph + open the drawer. Buy-now (name="return_to") stays
 * native → checkout. Never navigates to /cart on error (stays on page).
 */
(function () {
  'use strict';

  function getDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function openDrawer(dr) {
    try { if (typeof dr.open === 'function') { dr.open(); return; } } catch (e) {}
    try { if (typeof dr.showDialog === 'function') { dr.showDialog(); return; } } catch (e) {}
    try {
      var trigger = dr.querySelector('button[aria-haspopup="dialog"]');
      if (trigger) trigger.click();
    } catch (e) {}
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      // NB: form.id is DOM-clobbered by <input name="id">, so read the attribute.
      if (!form || !form.getAttribute || form.getAttribute('id') !== 'evob2-form') return;

      // Buy-now → native submit to checkout.
      var submitter = e.submitter;
      if (submitter && submitter.name === 'return_to') return;

      var drawer = getDrawer();
      if (!drawer) return; // No drawer → let it submit natively.

      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyEl = form.querySelector('[name="quantity"]');
      var atc = form.querySelector('#evob2-atc');
      var prevTxt = atc ? atc.textContent : '';
      if (atc) atc.disabled = true;

      function reset() {
        if (atc) { atc.disabled = false; atc.textContent = prevTxt; }
      }

      var itemsComp = drawer.querySelector('cart-items-component');
      var sectionId = itemsComp ? itemsComp.dataset.sectionId : null;

      var payload = {
        id: Number(idEl.value),
        quantity: Number((qtyEl && qtyEl.value) || 1)
      };
      if (sectionId) {
        payload.sections = sectionId;
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, data: j }; });
        })
        .then(function (res) {
          if (!res.ok) { reset(); return; } // add rejected → stay on page
          try {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: null,
                  sourceId: 'evob2-pdp',
                  data: {
                    source: 'product-form-component',
                    sections: (res.data && res.data.sections) || {}
                  }
                }
              })
            );
          } catch (e) {}
          openDrawer(drawer);
          reset();
        })
        .catch(function () { reset(); }); // network error → stay on page
    },
    true
  );
})();
